import * as Immutable from 'immutable';
import { StoreVariantPayload, StoreVariantStore } from './StoreVariantStore';

export type StoreProductSyncState = 'synced' | 'not-synced' | 'partially' | 'ignored'

export type StoreProductPayload = {
  id: number
  id_store: string
  external_id: string
  title: string
  preview: string
  synced: boolean
  sync_state: StoreProductSyncState
  store_url: string
  listVariants: StoreVariantPayload[]
}

interface IStoreProductStore {
  id: number
  id_store: string
  external_id: string
  title: string
  preview: string
  synced: boolean
  sync_state: StoreProductSyncState
  store_url: string
  listVariants: Immutable.OrderedMap<string, StoreVariantStore>
}

const defaultStoreProductStore = Immutable.Record<IStoreProductStore>({
  id: 0,
  id_store: '',
  external_id: '',
  title: '',
  preview: '',
  synced: false,
  sync_state: 'not-synced',
  store_url: '',
  listVariants: Immutable.OrderedMap<string, StoreVariantStore>(),
});

export class StoreProductStore extends defaultStoreProductStore implements IStoreProductStore {}
